<template>
  <div class="member-active-curve flex-center">
    <div v-loading="loading" id="chartCurve" style="width: 100%; height:200px" />
  </div>
</template>
  
<script>
import { debounce } from "@/utils/common";
import { getBehavioractivationApi } from "@/api/up/upMemberApi";

export default {
  name: "MemberActiveCurve",
  props: {
    memberid: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      unit: "",
      chart: null,
      loading: false,
      chartOption: {
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: '10%',
          bottom: '20%',
          right: 0,
          left: '10%'
        },
        xAxis: {
          // name: '日期',
          type: "category",
          boundaryGap: false,
          data: [],
        },
        yAxis: {
          axisLine: {
            show: false,
          },
          type: "value",
        },
        series: [
          {
            type: "line",
            lineStyle: {
              width: 1
            },
            smooth: false,
            color: "#07c160",
            showSymbol: false,
            data: []
          }
        ]
      }
    };
  },

  created: function () {
    this.fetchData();
  },

  mounted() {
    this.initChart();
    this.__resizeHandler = debounce(() => {
      if (this.chart) {
        this.chart.resize();
      }
    }, 100);
    window.addEventListener("resize", this.__resizeHandler);
  },

  methods: {
    fetchData() {
      this.loading = true;
      getBehavioractivationApi({ memberid: this.memberid }).then(res => {
        this.loading = false;
        if (!res.errno) {
          // this.chartOption.series[0].data = res.data
          const temp = res.data;
          const temp2 = temp.map(item => {
            return item[0];
          });
          this.chartOption.xAxis.data = temp2.map(item => {
              return item.slice(5,10);
          })

          this.chartOption.series[0].data = temp.map(item => {
            return item[1]
          })
          //   this.chartOption.series[0].data = [20,30,40,50,10]
          if (this.chart) {
            this.chart.setOption(this.chartOption);
          }
        }
      });
    },

    initChart() {
      this.chart = this.$echarts.init(
        document.getElementById('chartCurve'),
        "teenager"
      );
      this.chart.setOption(this.chartOption);
    },
  }
};
</script>
